import { SKIP_PAYMENT_INVOICE_LATER } from "constants/cart";
import { boolean, number, object, string } from "yup";

export const addAdhocTaskSchema = object({
  title: string().required("Please enter filing name"),
  adhoc_scope_of_work: string().required("Please enter scope of work"),
  payment_amount: string().required("Please enter price"),
  base_task_template_id: string().required("Please select entity"),
  entity: string().required("Please select Entity"),
  deadline: string().required("Please select Deadline"),
  season: string().required("Please select Season"),
});

export const addTaskSchema = object({
  entity: string().required("Please select Entity"),
  default_task_template: boolean(),
  season: string().when(["default_task_template", "base_task_template_id"], {
    is: (defaultTaskTemplate, baseTaskTemplateId) =>
      !defaultTaskTemplate ||
      baseTaskTemplateId ===
        process.env.PUBLIC_BASE_TASK_TEMPLATE_ID_BOOKKEEPING_CATCHUP,
    then: string().required("Please select Season"),
    otherwise: string().notRequired(),
  }),
  state_id: string().when("has_states", {
    is: true,
    then: string().required("Please select state"),
    otherwise: string().notRequired(),
  }),
  deadline: string().when("$needDeadline", {
    is: true,
    then: string().required("Please select Deadline"),
    otherwise: string().notRequired(),
  }),
  skipPaymentMode: string().required("Please select an option to continue"),
  amount: number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .when("skipPaymentMode", {
      is: SKIP_PAYMENT_INVOICE_LATER,
      then: (schema) => schema.min(1).required("Please add Amount"),
      otherwise: (schema) => schema.notRequired(),
    }),
});
